import { TENANT_LOGIN_ID } from "./api.utils";

export enum PublicRoutes {
  LOGIN = "/login",
  LOGOUT = "/logout",
  DEMO_LOGIN = "/demo",
  SIGNUP = "/signup",
  AUTH_CALLBACK = "/auth/callback",
  TRAINING_COMPLETION = "/training/completed",
}

export enum SurveyRoutes {
  PREVIEW_SURVEY = "/survey/preview",
  START_SURVEY = "/survey/start",
  SHORT_SURVEY = "/s", // In case links need to be shortened for examples in sms sendings
}

export enum ProtectedRoutes {
  DASHBOARD = "/dashboard",
  WORKPLACE_CULTURE = "/workplace-culture", // TODO change to inclusion-pulse in nextjs
  DIVERSITY_RATIO = "/diversity-ratio",
  LAUNCH = "/launch",
  PAY_EQUITY = "/pay-equity",
  PIPELINE = "/pipeline",
  SETTINGS = "/settings",
  TRAINING = "/training",
  CHAPTER = "/chapter",
  REPORT = "/report",
  ACTION_PLAN = "/action-plan",
}

export const isPublicRoute = (route: string): boolean => {
  return (
    Object.values(PublicRoutes).some((publicRoute) =>
      route.startsWith(publicRoute)
    ) || isSurveyRoute(route)
  );
};

export const isSurveyRoute = (route: string): boolean => {
  return Object.values(SurveyRoutes).some((surveyRoute) =>
    route.startsWith(surveyRoute)
  );
};

export const getLoginRoute = (): string => {
  const tenantLoginId = localStorage.getItem(TENANT_LOGIN_ID);
  if (tenantLoginId) {
    return `${PublicRoutes.LOGIN}/${tenantLoginId}`;
  } else {
    return PublicRoutes.LOGIN;
  }
};
